import {useQuery} from 'react-query';

const mmsApiUrl = `${process.env.MMS_URL}/mms/api/out`;

const fetchStyleById = async (styleId) => {
  const response = await fetch(`${mmsApiUrl}/styles/${styleId}.json`);
  if (!response.ok) {
    throw new Error('Network response was not ok');
  }
  return response.json();
};

const useStyleById = (styleId) => {
  return useQuery(['style', styleId], () => fetchStyleById(styleId), {
    enabled: !!styleId
  });
};

export default useStyleById;
